function TermMeedyVO(id, insurer, resource, patient, additionalRemarks, verificationCode, executionDate, type, eventName, status,
                     statusReason, statusDescription, allDay, begin, end, place, description, cyclic, cyclicTerm, idOrder,
                     patientFirstName, patientLastName, patientIdentifier, patientPhone, patientAddress, verified,
                     suite, suiteName, suitePrice, payer, fromMeedyDoctors, nfz, referrals, payU, zm) {

    this.id = id;
    this.insurer = insurer;
    this.resource = resource;
    this.patient = patient;
    this.additionalRemarks = additionalRemarks;
    this.verificationCode = verificationCode;
    this.executionDate = executionDate;
    this.type = type;
    this.eventName = eventName;
    this.status = status;
    this.statusReason = statusReason;
    this.statusDescription = statusDescription;
    this.allDay = allDay === true;
    this.begin = begin;
    this.end = end;
    this.place = place;
    this.description = description;
    this.cyclic = cyclic === true;
    this.cyclicTerm = cyclicTerm;
    this.idOrder = idOrder;
    this.patientFirstName = patientFirstName;
    this.patientLastName = patientLastName;
    this.patientIdentifier = patientIdentifier;
    this.patientPhone = patientPhone;
    this.patientAddress = patientAddress;
    this.verified = verified === true;
    this.suite = suite;
    this.suiteName = suiteName;
    this.suitePrice = suitePrice;
    this.payer = payer;
    this.fromMeedyDoctors = fromMeedyDoctors;
    this.nfz = nfz;
    this.referrals = referrals;
    this.payU = payU;
    this.zm = zm;


    var _typeContext = {
        cyclicTerm: CyclicTermMeedyVO,
        executionDate: Date,
        insurer : InsurerMeedyVO,
        resource : ResourceMeedyVO,
        patient : PatientMeedyVO,
        statusReason : StatusReasonVO,
        begin : Date,
        end : Date,
        suite : SuiteMeedyVO,
        referrals: P1EReferralTermVO,
        zm: ZMVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
